/* eslint-disable camelcase */
/* @flow strict */

/* eslint-disable max-len */

import * as React from 'react';
import CodeCard from '/client/src/components/panel/codeCard';

import './styles.scss';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import SimpleSelect from '/client/src/components/forms/select';
import { GET, PUT } from '/client/src/api';

type PropsType = {
  eventId: string | number,
  _eventDetail?: {}
};

const CodesPage = ({ eventId, _eventDetail }: PropsType): React.Element<'div'> => {
  const context = React.useContext(EventDetailContainerContext);
  const defaultContext = React.useContext(DefaultContainerContext);
  const eventDetail = _eventDetail ? _eventDetail : context.eventDetail;
  const [ticketLevelByButtonTicket, setTicketLevelByButtonTicket] = React.useState(_.get(eventDetail, 'tickets.[0].id', null));
  const [discountEmbeded, seTdiscountEmbeded] = React.useState(_.get(eventDetail, 'discounts.[0].id', null));
  const [calendarTheme, setCalendarTheme] = React.useState('Classic');
  const [isCalendarChecked, setCalendarChecked] = React.useState(true);
  const [isCardChecked, setCardChecked] = React.useState(true);
  const [isFacebookChecked, setFacebookChecked] = React.useState(true);
  const [isSplashPageChecked, setSplashPageChecked] = React.useState(_.get(eventDetail, 'splash_page.is_active', true));
  const [facebookPageId, setFacebookPageId] = React.useState('');
  const [facebookUsers, setFacebookUsers] = React.useState([]);


  const handleCalendarTheme = (calendar_theme: string) => {
    setCalendarTheme(calendar_theme);
    defaultContext.setProfileCurrent({
      ...defaultContext.profileCurrent,
      calendar_theme
    });
  };

  async function fetchCalendarTheme() {
    try {
      const { result } = await GET('/api/v1/1/merchants/calendar_theme');
      const theme = _.get(result, 'calendar_theme', 'Classic');

      setCalendarTheme(theme);
    } catch (e) {
      console.log(e);
    }
  }
  async function fetchCalendar() {
    try {
      const { result } = await GET(`/api/v1/1/merchants/events/${eventId}/calendar`);
      const isDisplay = _.get(result, 'is_display', true);

      setCalendarChecked(isDisplay);
    } catch (e) {
      console.log(e);
    }
  }
  async function fetchCard() {
    try {
      const { result } = await GET(`/api/v1/1/merchants/events/${eventId}/card`);
      const isDisplay = _.get(result, 'is_display', true);

      setCardChecked(isDisplay);
    } catch (e) {
      console.log(e);
    }
  }
  async function fetchFacebook() {
    try {
      const { result } = await GET(`/api/v1/1/merchants/facebookpages/${facebookPageId}/events/${eventId}`);
      const isDisplay = _.get(result, 'is_display', true);

      setFacebookChecked(isDisplay);
    } catch (e) {
      console.log(e);
    }
  }
  async function setSplashPage() {
    try {
      await PUT(`/api/v1/1/splashpages/${eventId}`, { is_active: !isSplashPageChecked });
      setSplashPageChecked((prevState: any): void => !prevState);
    } catch (e) {
      console.log(e);
    }
  }
  async function setCard() {
    try {
      await PUT(`/api/v1/1/merchants/events/${eventId}/card`, { is_display: !isCardChecked });
      setCardChecked((prevState: any): void => !prevState);
    } catch (e) {
      console.log(e);
    }
  }
  async function setCalendar() {
    try {
      await PUT(`/api/v1/1/merchants/events/${eventId}/calendar`, { is_display: !isCalendarChecked });
      setCalendarChecked((prevState: any): void => !prevState);
    } catch (e) {
      console.log(e);
    }
  }
  async function setFacebook() {
    try {
      await PUT(`/api/v1/1/merchants/facebookpages/${facebookPageId}/events/${eventId}`, { is_display: !isFacebookChecked });
      setFacebookChecked((prevState: any): void => !prevState);
    } catch (e) {
      console.log(e);
    }
  }
  async function facebookCurrent() {
    try {
      const { result } = await GET('/api/v1/1/merchants/facebook/current');

      const _facebookUsers = result;
      const pages = [];

      setFacebookUsers(_facebookUsers);
      for (const user of _facebookUsers) {
        if (user.facebook_pages.length > 0) {
          pages.push(...user.facebook_pages);
        }
        if (pages.length > 0) {
          setFacebookPageId(pages[0].page_id);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  const getFBPagesLength = (): boolean => {
    const pages = [];

    for (const user of facebookUsers) {
      if (user.facebook_pages.length > 0) {
        pages.push(...user.facebook_pages);
      }
    }
    return pages.length > 0;
  };

  const hasFBPages = getFBPagesLength();

  React.useEffect(() => {
    fetchCalendarTheme();
    fetchCalendar();
    fetchCard();
    //  fetchFacebook();
    facebookCurrent();
  }, []);

  return (
    <div className='CodesPage'>
      <div className="preview-codes">
        <div className="panel panel-default panel-page">
          <div className="panel-heading panel-heading-color1">
            <div className="panel-title">
              <span>Integration Codes & URLs</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <CodeCard
              switcher
              switcherLabel='Splash page url'
              switcherChecked={isSplashPageChecked}
              switcherCallback={setSplashPage}
              imageClass='splashpage'
              reason='splash'
              eventDetail={eventDetail}
              content={`${process.env.EVENT_HOST}${_.get(eventDetail, 'url_name', '')}`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              switcher
              switcherLabel='FACEBOOK APP URL'
              switcherChecked={isFacebookChecked}
              switcherCallback={setFacebook}
              imageClass='fb-app'
              reason='facebook'
              reasonOptions={{ page_id: facebookPageId }}
              eventDetail={eventDetail}
              extraContent={
                hasFBPages ?
                  <div className="form-control" style={{ border: 'none' }}>
                    <div className="form-group SimpleInput">
                      <select
                        className="form-control styled-select"
                        data-bind="value:select_fb_page_id"
                        onChange={(e: any): void => setFacebookPageId(e.target.value)}
                      >
                        {
                          facebookUsers.map((user: any, i: number): any => (
                            <optgroup key={i} label={`${user.user_name || 'user'} (${user.email_address || 'user'})` || 'user'} data-bind="attr:{label:user_name+'('+email_address+')'},foreach:facebook_pages">
                              {
                                user.facebook_pages.map((page: any, j: number): any => (
                                  <option key={j} value={page.page_id}>{page.page_name}</option>
                                ))
                              }
                            </optgroup>
                          ))
                        }
                      </select>
                    </div>
                    <textarea
                      className="form-control fb-textarea"
                      readOnly
                      rows="4"
                      defaultValue={facebookPageId && `${process.env.EVENT_HOST}facebook/${facebookPageId}?_dc=${Math.ceil(new Date().getTime() / 1000)}`}
                    />
                  </div>
                  :
                  <p className='no-fb-pages-msg'>You will need to install our Sparxo Facebook app to use the feature, <a href="/integrations/facebook-app/pages">Click here</a> to install our Facebook app.</p>
              }
              noContent
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              switcher
              switcherLabel='EVENT CARD LIST'
              switcherChecked={isCardChecked}
              switcherCallback={setCard}
              imageClass='cards'
              reason='cards'
              eventDetail={eventDetail}
              content={`<div class="sparxo-nest-cards sparxo-id-${_.get(eventDetail, 'creator_user_id', '')}"></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              switcher
              customize
              switcherLabel='CALENDAR'
              switcherChecked={isCalendarChecked}
              switcherCallback={setCalendar}
              imageClass='calendar'
              reason='calendar'
              eventDetail={eventDetail}
              calendarTheme={calendarTheme}
              setCalendarTheme={handleCalendarTheme}
              content={`<div class="sparxo-nest-calendar sparxo-theme-${calendarTheme && calendarTheme.toLowerCase()} sparxo-id-${_.get(eventDetail, 'creator_user_id', '')} "></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              title='EVENT BUTTON CODE'
              imageClass='event-button'
              reason='button'
              eventDetail={eventDetail}
              content={`<a class="sparxo-button-style sparxo-nest-button sparxo-id-${eventId} sparxo-type-1" href="${process.env.EVENT_HOST}${_.get(eventDetail, 'url_name', '')}" target="_blank">Buy Tickets</a><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              title='SPECIFIC TICKET LEVEL BUY BUTTON'
              imageClass='ticket-button'
              extraContent={
                <SimpleSelect
                  value={ticketLevelByButtonTicket ? ticketLevelByButtonTicket : ''}
                  items={_.map(_.get(eventDetail, 'tickets', []), (t: {}): {} => {
                    return {
                      label: t.name,
                      value: t.id
                    };
                  })}
                  callBack={(e: any) => {
                    setTicketLevelByButtonTicket(e.target.value);
                  }}
                />
              }
              textAreaWrapClassList='h80'
              reason='button'
              eventDetail={eventDetail}
              content={`<a class="sparxo-button-style sparxo-nest-button sparxo-id-${eventId} sparxo-ticket-${ticketLevelByButtonTicket} sparxo-type-1" href="${process.env.EVENT_HOST}${_.get(eventDetail, 'url_name', '')}" target="_blank">Buy Tickets</a><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              title='EMBEDDED WIDGET'
              imageClass='embedded'
              reason='embed'
              eventDetail={eventDetail}
              content={`<div class="sparxo-nest-embed sparxo-id-${eventId} sparxo-type-1"></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
          <div className="col-md-6">
            <CodeCard
              title='EMBEDDED WIDGET WITH DISCOUNT'
              imageClass='embedded'
              extraContent={
                <SimpleSelect
                  value={discountEmbeded ? discountEmbeded : ''}
                  items={_.map(_.get(eventDetail, 'discounts', []), (t: {}): {} => {
                    return {
                      label: t.coupon_code,
                      value: t.id
                    };
                  })}
                  callBack={(e: any) => {
                    seTdiscountEmbeded(e.target.value);
                  }}
                />
              }
              textAreaWrapClassList='h80'
              reason='embed'
              reasonOptions={{
                code: _.get(_.find(_.get(eventDetail, 'discounts', []), (d: {}): {} => d.id === discountEmbeded), 'coupon_code', 0)
              }}
              eventDetail={eventDetail}
              content={`<div class="sparxo-nest-embed sparxo-id-${eventId} sparxo-code-${discountEmbeded} sparxo-type-1"></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodesPage;
